module.exports = __webpack_public_path__ + "static/media/fl_press_kit.f08d41cd.pdf";